import { FlattenSimpleInterpolation } from 'styled-components'

import { AppName } from 'root-constants'

import { femiTheme } from './femiTheme'
import { luvlyTheme } from './luvlyTheme'

export const FLOW_THEMES: Partial<Record<AppName, FlattenSimpleInterpolation>> =
  {
    [AppName.FEMI]: femiTheme,
    [AppName.LUVLY]: luvlyTheme,
  }
